export const budget_rating_labels: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: 'Cheapest',
  2: 'Cheap',
  3: 'Mid-range',
  4: 'Semi-gourmet',
  5: 'Gourmet',
};
